// import { deleteUserAuthData } from "@/actions/cookies";
// import useUserAuthStore from "@/store/userAuthDataStore";
// import { configureStore } from "../store/store";
import axios from "axios";
import useUserAuthStore from "../zStore/userAuth";
// import { redirect } from "next/navigation";
const Axios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // timeout: 10000,
  params: {}, // do not remove this, its added to add params later in the config
});

// Add a request interceptor
Axios.interceptors.request.use(
  function (config) {
    // console.log(configureStore.getState);
    const { data } = useUserAuthStore.getState();

    if (data) {
      config.headers.Authorization = data?.data;
      // config.headers["ngrok-skip-browser-warning"] = "allow";
    }
    //
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
Axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  async function (error) {
    if (error?.response?.status === 401) {
      //   const { setLogout } = useUserAuthStore.getState();
      //   await deleteUserAuthData();
      //   setLogout();
      //   window.location = "/login";
    }

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export default Axios;
